import React from "react";
import styled from "styled-components";
import { Button } from "react-bootstrap";
import { useHomepage } from "src/context/homepage/homepage.provider";

const TournamentSectionalTabs = ({
  subTabs,
  bgColor,
  activeBgColor,
  className,
}) => {
  const { tournamentsSubtabsFn, tournamentsSubtabs } = useHomepage();
  return (
    <Div
      className={className || "sectional-tournament-tabs"}
      bgColor={bgColor}
      activeBgColor={activeBgColor}
    >
      {Object.keys(subTabs).map((key, index) => (
        <Button
          key={key}
          className={
            tournamentsSubtabs === index + 1
              ? "active nav-fill"
              : "nav-fill gap-2"
          }
          onClick={() => tournamentsSubtabsFn(index + 1)}
          variant="pills"
        >
          {subTabs[key].label}
        </Button>
      ))}
    </Div>
  );
};

const Div = styled.div`
  width: 100%;
  max-width: 1200px;
  height: auto;
  margin: 20px auto;
  display: flex;
  flex-flow: row wrap;
  gap: 0.5rem;
  justify-content: center;
  align-items: stretch;
  z-index: 9;

  button {
    background-color: ${(props) => props.bgColor || "var(--mutedred)"};
    color: var(--white);
    border: none;
    border-radius: 0;
    padding: 0.8rem 1.25rem;
    height: auto;
    width: auto;
    max-width: none;
    min-height: unset;
    flex: 1 1 10rem;
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover,
    &.active {
      background-color: ${(props) => props.activeBgColor || "var(--black)"};
      color: var(--white);
    }
  }

  @media (max-width: 768px) {
    button {
      flex: 1 1 100%;
      max-width: 100%;
    }
  }

  &.section-pad {
    margin-top: 40px;
  }

  &.section-pad + div {
    padding-bottom: 40px;
  }

  &.section-pad + div > container-div > :last-child,
  &.section-pad + div > container-div > :last-child > :last-child {
    margin-bottom: 0;
  }
`;

export default TournamentSectionalTabs;
